export const swiperjs = () => {
  // Marquee Swipers (Hero and Unlock sections)
  const marqueeConfig = {
    slidesPerView: "auto",
    spaceBetween: 24,
    loop: true,
    speed: 5000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      reverseDirection: true,
    },
  };

  const marqueeReverseConfig = {
    ...marqueeConfig,
    speed: 40000,
    spaceBetween: 0,
    slidesPerView: 0.7,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
      },
    },
  };

  if (typeof Swiper !== 'undefined') {
    const badgeSwiper = document.querySelector(".badgeSec__swiper");
    if (badgeSwiper) {
      new Swiper(".badgeSec__swiper", marqueeConfig);
    }

    const jellySwiper = document.querySelector(".jellySec__swiper");
    if (jellySwiper) {
      new Swiper(".jellySec__swiper", marqueeReverseConfig);
    }
  }
};
